import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAdminHelperFunction from "../components/DynamicField/useAdminHelperFunction";
import { resetLoginData } from "../redux/features/loginSlice";
import { clearAllHcpState } from "CHECKOUT/HcpSlice";
import { clientAppVersion } from "./globalVar";
import {
  clearMultipleAddressesState,
  // deleteAllAddressesThunk,
} from "CHECKOUT/addressSlice";
import { setRelodeLandingPage } from "../redux/features/landingSlice";

export const useLogout = () => {
  const login = useSelector((state) => state.login);
  const { companyNumber } = login;
  const { user } = useSelector((state) => state.accountManage);
  const { adminData } = useSelector((state) => state.support);
  const dispatch = useDispatch();
  const count = useRef(false);
  const { relodeLandingPage, appVersion } = useSelector(
    (state) => state.landing
  );
  const appName = useAdminHelperFunction("appName");
  const footer = useAdminHelperFunction("siteFooter");
  const [ssoFlagStatus, setSsoFlagStatus] = useState(false);
  const [comp, setComp] = useState("");
  const [sso, setSso] = useState("");

  useEffect(() => {
    setComp(companyNumber);
    setSso(user?.ssoFlag);
  }, []);

  const logout = () => {
    const ssoF = user?.ssoFlag ? true : false;
    setSsoFlagStatus(ssoF);
    count.current = Boolean(ssoF);
    dispatch(clearAllHcpState());
    dispatch(clearMultipleAddressesState());
    // dispatch(deleteAllAddressesThunk());
    dispatch(resetLoginData());
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem("userInfo");
    localStorage.clear();
    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    // console.log(sso, "sso console from logout function");
    // console.log(
    //   count.current,
    //   "sso count current console from logout function"
    // );
    // console.log(
    //   ssoFlagStatus,
    //   "sso ssoFlagStatus console from logout function"
    // );
    // if (relodeLandingPage === 0) {
    //   dispatch(setRelodeLandingPage(1));
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 0);
    // }

    localStorage.setItem("version", appVersion ? appVersion : clientAppVersion);
    localStorage.setItem("AppName", appName ? JSON.stringify(appName) : "");
    localStorage.setItem("companyNumber", comp ? JSON.stringify(comp) : "");
    localStorage.setItem("footer", footer ? JSON.stringify(footer) : "");
    localStorage.setItem("ssoFlagStatus", sso ? true : false);
  };

  return { logout, ssoFlagStatus, count, dispatch };
};
